import $http from '@/config/request';
import { $Cookies } from '@/utils';

// oauth2标识符
const SECRET = {
  client_id: 'u5UraXU4Ta7UR59yL4XH2ATdv4PDrd2n',
  client_secret: '0V74mkSO9ZrRh7Mu0SynAakVITLXKNdh'
};

//获取token
export const getTokenApi = () => {
  return $http.post('/token/getToken', SECRET);
};


//刷新token
export const refreshTokenApi = () => {
  const _refresh_token = $Cookies.get('refresh_token');
  const params = {
    ...SECRET,
    refresh_token: _refresh_token
  };
  return $http.post('/token/refreshToken', params);
};


//注册前检测手机号是否已注册
export const checkPhoneBind = params => {
  return $http.post('/g12eLogin/register/checkPhoneBind', params);
};

// 发送短信
export const getSMSCode = params => {
  return $http.post('/g12eLogin/login/sendMsg', params);
};

//PC注册接口
export const pcRegister = params => {
  return $http.post('/g12eLogin/register/register', params);
};

//用户名/手机号密码登录接口
export const loginByMobile = params => {
  return $http.post('/g12eLogin/login/mobile', params);
};

// 用户名、密码登录接口
export const loginByAccount = params => {
  return $http.post('/g12eLogin/login/password', params);
};

//检测是否需要图片验证码（账号登录）
export const checkNeedImgCode = () => {
  return $http.post(`/g12eLogin/login/ifShowPhoto`);
};

//注册前检查手机号验证码
export const checkMobileSmsCode = params => {
  return $http.post('/g12eLogin/register/checkPhone', params);
};

//检查是否登录(会返回用户信息)
export const verifyLogin = () => {
  return $http.post('/g12eLogin/login/isLogin');
};
//检查是否登录2(会返回是否登录)
export const isLoginApi = () => {
  return $http.post('/g12eLogin/login/verifyLogin');
};

//退出
export const logout = () => {
  return $http.post('/g12eLogin/login/logout');
};
